var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view_box",class:_vm.isAni ? 'ani':''})
}
var staticRenderFns = []

export { render, staticRenderFns }